module.exports = __webpack_public_path__ + "img/arrow-ios-forward.642048e4.svg";